import * as Animation from "./animation";
import * as Config from "./config";
import * as Time from "./time";

import { Quaternion, TargetCamera, Vector3 } from "babylonjs";

//import { Noise } from "./perlin.js";
import { getRotation } from "./helpers";
import store from "./store";
import VueStore from "@/store";

// eslint-disable-next-line
const Noise = require("./perlin.js").Noise;

let defaultPosition: Vector3;
let defaultTarget: Vector3;

let seed: number = Date.now();

function create() {
  const camera = new TargetCamera("mainCamera", Vector3.Zero(), store.scene);

  // if (window.matchMedia("(min-width: 600px)").matches) {
  //   camera.fov = 1.0;
  //   console.log("min width 600px", camera.fov);
  //   console.log(window.matchMedia("(min-width: 600px)").matches);
  // } else {
  //   // 1
  // }

  if (VueStore.state.isResultsPage) {
    //camera.fov = 0.4;
    VueStore.state.isMobile ? (camera.fov = 0.4) : (camera.fov = 0.4);
  } else {
    //camera.fov = 1.2;
    VueStore.state.isMobile ? (camera.fov = 1.2) : (camera.fov = 0.5);
  }

  store.mainCamera = camera;

  const screenshotCam = new TargetCamera(
    "screenshotCam",
    Vector3.Zero(),
    store.scene
  );

  screenshotCam.fov = 0.5;

  store.mainCamera = camera;
  store.screenshotCamera = screenshotCam;

  setDefaultPosition(Vector3.Zero());
  setDefaultTarget(Vector3.Zero());
}

function setDefaultPosition(pos: Vector3) {
  defaultPosition = pos;

  store.mainCamera.position = defaultPosition;
  store.screenshotCamera.position = defaultPosition;
}

function setDefaultTarget(target: Vector3) {
  defaultTarget = target;

  store.screenshotCamera.rotationQuaternion = Quaternion.FromEulerVector(
    getRotation(store.mainCamera.position, target)
  );

  setTarget(defaultTarget);
}

function getDefaultPosition() {
  return defaultPosition.add(getShakeFactor());
}

function setTarget(target: Vector3) {
  store.mainCamera.rotationQuaternion = Quaternion.FromEulerVector(
    getRotation(store.mainCamera.position, target)
  );
}

function animateTo(pos: Vector3, target: Vector3, time: number): number {
  // Position
  const animLength = Animation.animatePropertyVector3(
    store.mainCamera,
    "position",
    time,
    store.mainCamera.position,
    pos
  );

  // Rotation
  Animation.animatePropertyQuaternion(
    store.mainCamera,
    "rotationQuaternion",
    time,
    store.mainCamera.rotationQuaternion,
    Quaternion.FromEulerVector(getRotation(pos, target))
  );

  return animLength;
}

function reset(instant = false) {
  if (instant) {
    store.mainCamera.position = getDefaultPosition();
    setTarget(defaultTarget);

    Animation.setAnimating(false);
  } else {
    const animLength = animateTo(
      getDefaultPosition(),
      defaultTarget,
      Config.CAMERA_ANIMATION_LENGTH
    );

    if (Animation.animationStatus.value !== Animation.AnimationStatus.Idle) {
      Animation.setAnimationStatus(Animation.AnimationStatus.AnimatingOut);
    }

    setTimeout(() => {
      Animation.setAnimating(false);
      Animation.setAnimationStatus(Animation.AnimationStatus.Idle);
    }, animLength);
  }
}

function tick() {
  if (Animation.animationStatus.value === Animation.AnimationStatus.Idle) {
    store.mainCamera.position = getDefaultPosition();
    store.mainCamera.setTarget(defaultTarget);
  }
}

function getShakeFactor(): Vector3 {
  const speed = 0.00005;
  const shakeAmount = 20; //2.5;

  const xScale = 1;
  const yScale = 0.1;

  //calculate random number using x and y position
  const randX = Noise.perlin2(
    store.mainCamera.position.x * speed,
    seed * speed
  );
  const randY = Noise.simplex2(
    store.mainCamera.position.y * speed,
    seed * speed
  );

  seed += Time.deltaTime() * 1000;

  // return Vector3.Zero();
  return new Vector3(
    randX * xScale * shakeAmount,
    randY * yScale * shakeAmount,
    0
  );
}

export {
  create,
  tick,
  setDefaultPosition,
  setDefaultTarget,
  setTarget,
  reset,
  animateTo,
};
